import { CrmCollaborationTaskFeaturePage } from "..";

type CrmCollaborationTaskPageProps = {
  initialTab?: "tasks" | "tele_sales" | "strong_follow" | "my_items";
};

/** CRM 协作任务页面。 */
export function CrmCollaborationTaskPage({ initialTab }: CrmCollaborationTaskPageProps = {}) {
  return <CrmCollaborationTaskFeaturePage initialTab={initialTab} />;
}
